export default "__VITE_ASSET__ChVq7BnK__"